import Message from './Message';

// export types
export type { MessageProps } from './Message';

// export components
export { Message };
export default Message;
